module.exports = __webpack_public_path__ + "static/media/menu-icon.33ee47e6.svg";